import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus, faSignInAlt, faCircle} from '@fortawesome/free-solid-svg-icons'
import {CsvButton4} from './CsvButton3';
import MassEdit from './MassEdit'
import DeviceEdit from './DeviceEdit'
import SwapDevice from './SwapDevice'

import '../../Overview/overview.css'
import './buttonbar.css'

export default class ButtonBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: false,
      modalOpened: 0,
      deviceModal: false
    };
    this.showAddDevice = this.showAddDevice.bind(this)
    this.deviceEdit = this.deviceEdit.bind(this)
    this.subscribe = undefined;
  }
  componentDidMount(){
  }
  componentDidUpdate(prevProps) {
  }

  massEdit (state) {
    this.setState({"modalShow": state})
  }
  deviceEdit (state) {
    if (state?.refresh && this.props.onUpdate)
      this.props.onUpdate()
    this.setState({deviceModal: false})
  }
  showAddDevice () {
    this.setState({deviceModal: true, modalOpened: this.state.modalOpened+1})
  }
  render() {
    const fImport = this.props?.FileImport ?? (()=>{});
    return (
      <>
      <div className="button-grid">
        <span className="fa-stack action-button" onClick={this.showAddDevice}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faPlus} color="#257461" className="fa-stack-1x" />
        </span>
       <span className="fa-stack action-button" onClick={()=>fImport()}>
          <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
          <FontAwesomeIcon icon={faSignInAlt} color="#257461" className="fa-stack-1x" />
        </span>
        <CsvButton4 {...this.props} />
        <span className="button-caption">Add Device</span>
        <span className="button-caption">Import CSV</span>
        <span className="button-caption">Download CSV</span>
        </div>

        <MassEdit show={this.state.modalShow} hide={()=>this.massEdit(false)} count={this.props.massEdit} 
          onChange={this.props.onMassEdit}/>

        <DeviceEdit {...this.props} opened={this.state.modalOpened} show={this.state.deviceModal} onHide={this.deviceEdit} />

        <SwapDevice {...this.props} show={this.state.swapModal} onHide={this.swapHide}/>
      </>
      );
    }
}
